<template>
  <path
    d="M10.221 3.278l4.501 4.501-9.773 9.773-4.013 0.443c-0.537 0.059-0.991-0.395-0.931-0.932l0.446-4.016 9.77-9.769zM17.506 2.608l-2.113-2.113c-0.659-0.659-1.728-0.659-2.387 0l-1.988 1.988 4.501 4.501 1.988-1.988c0.659-0.66 0.659-1.728 0-2.387z"
  ></path>
</template>
